import { createReducer } from 'redux-create-reducer'
import type { BusinessUser } from 'types/user'
import {
  BUSINESS_USERS_CHANGE,
  BUSINESS_USERS_CHANGE_FAIL,
  BUSINESS_USERS_CHANGE_SUCCESS,
  BUSINESS_USERS_LOAD,
  BUSINESS_USERS_LOAD_FAIL,
  BUSINESS_USERS_LOAD_SUCCESS,
  BUSINESS_USERS_REMOVE,
  BUSINESS_USERS_REMOVE_FAIL,
  BUSINESS_USERS_REMOVE_SUCCESS,
} from '@disco/constants/ActionTypes'
export type BusinessUsersState = {
  loading: boolean
  loaded: boolean
  loadError?: unknown | null
  users: Record<string, BusinessUser>
}
const initialState: BusinessUsersState = {
  loading: false,
  loaded: false,
  loadError: null,
  users: {},
}

function update(state, id, updater) {
  const original = state.users[id]
  return {
    ...state,
    users: {
      ...state.users,
      [id]: { ...original, ...updater() },
    },
  }
}

export const businessUsersReducer = createReducer<BusinessUsersState, any>(
  initialState,
  {
    [BUSINESS_USERS_LOAD](state) {
      return { ...state, loading: true, loadError: null }
    },

    [BUSINESS_USERS_LOAD_SUCCESS](state, { businessUsers }) {
      const update = {}
      businessUsers.forEach(user => {
        update[user.id] = user
      })
      return {
        ...state,
        loading: false,
        loaded: true,
        loadError: null,
        users: { ...state.users, ...update },
      }
    },

    [BUSINESS_USERS_LOAD_FAIL](state, { error }) {
      return { ...state, loading: false, loadError: error }
    },

    [BUSINESS_USERS_CHANGE](state, { userId }) {
      return update(state, userId, () => ({
        changing: true,
        changingError: null,
      }))
    },

    [BUSINESS_USERS_CHANGE_SUCCESS](state, { userId, changes }) {
      return update(state, userId, () => ({
        ...changes,
        changing: false,
        changed: true,
      }))
    },

    [BUSINESS_USERS_CHANGE_FAIL](state, { userId, error }) {
      return update(state, userId, () => ({
        changing: false,
        changingError: error,
      }))
    },

    [BUSINESS_USERS_REMOVE](state, { userId }) {
      return update(state, userId, () => ({
        removing: true,
        removingError: null,
      }))
    },

    [BUSINESS_USERS_REMOVE_SUCCESS](state, { userId }) {
      return update(state, userId, () => ({
        removing: false,
        removed: true,
      }))
    },

    [BUSINESS_USERS_REMOVE_FAIL](state, { userId, error }) {
      return update(state, userId, () => ({
        removing: false,
        removingError: error,
      }))
    },
  },
)
